import {POST_QUERY} from "utils";

declare var $:any;

import * as React from 'react';
import {MainStageData} from "data/MainStageData";
import {observer} from "mobx-react";
import './MainStageQuestionWidget.pcss';
import {Button} from "components/widgets/Button";
import {computed, observable} from "mobx";
import * as ReactTimeout from 'react-timeout'

interface IMainStageQuestionWidget_Props {
  setTimeout?:(func:VoidFunction, ms:number)=>void;
}

@observer
class _MainStageQuestionWidget extends React.Component<IMainStageQuestionWidget_Props> {
  @observable question:string = '';

  @computed get submitDisabled() {
    return this.question.length===0;
  }

  @observable submittingQuestion:boolean = false;
  @observable questionSubmitted:boolean = false;

  onSubmitQuestion = () => {
    if(MainStageData.liveMainStageEvent) {
      this.submittingQuestion = true;
      $.ajax(POST_QUERY('/mainStageEventQuestions', {
        mainStageEventId: MainStageData.liveMainStageEvent._id,
        question: this.question
      }))
        .done(() => {
          this.submittingQuestion = false;
          this.questionSubmitted = true;
          this.question = "";
          if(this.props.setTimeout) {
            this.props.setTimeout(()=>{
              this.questionSubmitted = false;
            }, 3000)
          } else {
            this.questionSubmitted = false;
          }
        })
        .fail((err: any) => {
          this.submittingQuestion = false;
          this.questionSubmitted = false;
          alert('For some reason, your question did not go through. Please try again.')
        });
    }
  }

  render() {
    if(MainStageData.liveMainStageEvent) {
      return (
        <div className={"mainstage-question block"}>
          <h2>Submit a Question for Q&A</h2>
          <div className={"strv_row"}>
            <div className={"strv_col desc"}>
              <p>
                Mainstage presenters will answer your questions here during live Q&A. We encourage you to submit questions at any time during the session.
              </p>
            </div>
            <div className={"strv_col form"}>

              {this.submittingQuestion &&
              <div className={'submitted'}>

              </div>
              }

              {this.questionSubmitted &&
              <div className={'submitted'}>

                <h4>Thank you!</h4>
                <p>Your question was successfully submitted.</p>
              </div>
              }

              {!this.questionSubmitted && !this.submittingQuestion &&
                <React.Fragment>
                  <textarea placeholder={'enter your question...'} value={this.question} onChange={(e)=>{ this.question = e.target.value; }}/>
                  <Button onClick={this.onSubmitQuestion} disabled={this.submitDisabled} >Submit</Button>
                </React.Fragment>
              }

            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }

  }
}
export const MainStageQuestionWidget = ReactTimeout(_MainStageQuestionWidget);
